<template>
  <div class="patient-new width-responsiveness--centralized">
    <modal
      ref="transferModal"
      template="loading"
      ref-name="transferModal"
      title="Aguarde"
    >
      <p>Salvando Paciente...</p>
    </modal>

    <div class="patient-new__container">
      <subheader
        :title="title"
        :centralized="true"
        :back-button-visible="true"
      />

      <div
        v-if="loading"
        class="patient-new__loading"
      >
        <Spinner />
      </div>

      <div
        v-else
        class="patient-new__container input-forms"
      >
        <div class="patient-new__form">
          <card-form :collapsed="true">
            <div
              slot="expanded"
              class="form-container"
            >
              <md-layout
                :md-gutter="24"
                md-flex="100"
              >
                <!-- form title -->
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <h2
                    id="patientFormTitle"
                    class="orders-new__patient__title title-main"
                  >
                    Dados do Paciente
                  </h2>
                </md-layout>

                <!-- name field -->
                <md-layout
                  md-flex="75"
                  md-flex-medium="75"
                >
                  <md-input-container
                    id="patientName"
                    :class="{ 'md-input-invalid': errors.has('name') }"
                  >
                    <label>Nome do paciente *</label>
                    <md-input
                      id="txtNewPatientName"
                      v-model="patient.name"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="name"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Nome do paciente *"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <!-- Switch for Nome Social -->
                <md-layout
                  md-flex="25"
                  md-flex-medium="25"
                >
                  <md-switch
                    v-model="patient.socialNameEnabled"
                    class="md-primary"
                  >
                    Possui nome social?
                  </md-switch>
                </md-layout>

                <md-layout
                  v-if="patient.socialNameEnabled"
                  md-flex="100"
                  md-flex-medium="100"
                  style="height: 15px"
                />

                <!-- Nome Social field -->
                <md-layout
                  v-if="patient.socialNameEnabled"
                  md-flex="100"
                >
                  <md-input-container
                    id="patientSocialName"
                    :class="{ 'md-input-invalid': errors.has('social_name') }"
                  >
                    <label>Nome social</label>
                    <md-input
                      id="txtPatientSocialName"
                      v-model="patient.social_name"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="social_name"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Nome Social"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                  style="height: 15px"
                />

                <!-- cpf field -->
                <md-layout
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-input-container
                    id="patientCPF"
                    :class="{ 'md-input-invalid': errors.has('patient.cpf') }"
                  >
                    <label>
                      {{ cpfRequired ? 'CPF do paciente *' : 'CPF do paciente' }}
                    </label>
                    <md-input
                      id="txtPatientCPF"
                      v-model="patient.cpf"
                      v-mask="'###.###.###-##'"
                      v-validate="cpfRequired ? 'required|cpf_valid' : 'cpf_valid'"
                      maxlength="60"
                      type="text"
                      :placeholder="cpfRequired ? 'CPF do paciente *' : 'CPF do paciente'"
                      data-vv-validate-on="none"
                      name="patient.cpf"
                      @keydown.enter.native="focusNextField('txtNewNote')"
                    />
                    <span
                      v-if="errors.firstByRule('patient.cpf', 'cpf_valid')"
                      class="md-error"
                    >CPF Inválido</span>
                    <span
                      v-if="errors.firstByRule('patient.cpf', 'required')"
                      class="md-error"
                    >Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <!-- email field -->
                <md-layout
                  md-flex="50"
                  md-flex-medium="50"
                >
                  <md-input-container
                    id="patientEmail"
                    :class="{ 'md-input-invalid': errors.has('email') }"
                  >
                    <label> Email do Paciente </label>
                    <md-input
                      id="txtNewPatientEmail"
                      v-model="patient.email"
                      v-validate="'email'"
                      data-vv-validate-on="none"
                      name="email"
                      maxlength="60"
                      type="email"
                      title
                      placeholder="Email do paciente"
                    />
                    <span
                      v-if="errors.firstByRule('email', 'email')"
                      class="md-error"
                    >Email inválido</span>
                  </md-input-container>
                </md-layout>

                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                  style="height: 15px"
                />

                <!-- birthday field -->
                <md-layout
                  md-flex="30"
                  md-flex-medium="30"
                >
                  <md-input-container
                    id="patientBirthDate"
                    class="datepicker"
                    :class="{ 'md-input-invalid': errors.has('birthDate') }"
                  >
                    <label> Data de nascimento * </label>
                    <v-date-picker
                      v-model="patient.birthDate"
                      v-mask="'##/##/####'"
                      v-validate="'required|check_date_format:DD/MM/YYYY|not_future_date|after_date:31/12/1899'"
                      :pane-width="290"
                      :tint-color="'#7f1a54'"
                      mode="single"
                      maxlength="10"
                      type="text"
                      placeholder
                      data-vv-validate-on="none"
                      title
                      name="birthDate"
                      is-expanded
                    >
                      <div slot-scope="{ inputValue, updateValue }">
                        <md-input
                          id="dtNewBirthDate"
                          type="text"
                          :value="inputValue"
                          :placeholder="'Data de nascimento *'"
                          expanded
                          @change.native="
                            {
                              updateValue($event.target.value)
                            }
                          "
                        />
                      </div>
                    </v-date-picker>
                    <span
                      v-if="errors.firstByRule('birthDate', 'required')"
                      class="md-error"
                    >Obrigatório</span>
                    <span
                      v-else-if="errors.firstByRule('birthDate', 'check_date_format')"
                      class="md-error"
                    >Valor inválido</span>
                    <span
                      v-else-if="errors.firstByRule('birthDate', 'not_future_date')"
                      class="md-error"
                    >Data não pode ser maior que a atual</span>
                    <span
                      v-else-if="errors.firstByRule('birthDate', 'after_date')"
                      class="md-error"
                    >Ano deve ser maior que 1899</span>
                  </md-input-container>
                </md-layout>

                <!-- gender field -->
                <md-layout
                  md-flex="20"
                  md-flex-medium="20"
                >
                  <md-input-container
                    id="patientGender"
                    name="sexo"
                    :class="{
                      'md-input-placeholder md-advanced-select': true,
                      'md-has-value': patient.gender,
                      'md-input-invalid': errors.has('sexo')
                    }"
                  >
                    <label>Sexo *</label>
                    <advanced-select
                      id="cboNewSex"
                      v-model="patient.gender"
                      v-validate="'required'"
                      :options="genderOptions"
                      placeholder
                      :taggable="false"
                      :searchable="true"
                      name="sexo"
                      data-vv-validate-on="none"
                      title
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>
              </md-layout>
            </div>
          </card-form>
        </div>

        <div class="patient-new__doctor">
          <h3>Médicos relacionados</h3>
          <AddDoctor
            :opened="opened"
            :list-doctor="patient.doctors"
            @update="listDoctorsUpdated"
          />
        </div>

        <div class="patient-new__footer">
          <button
            class="btn-bordered"
            @click="$router.push('/patient')"
          >
            Cancelar
          </button>
          <button
            id="newPatientBtn"
            class="btn-primary"
            @click="validateBeforeSubmit()"
          >
            <img
              src="/static/images/icon-check-white.svg"
              alt="icone-salvar"
            >
            {{ isEdit ? 'Salvar alterações' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>
    <page-scroll-top />
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import patientService from '@/api/patient'
import Spinner from '@/components/common/Spinner'
import notify from '@/api/notification'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import strings from '@/strings'
import AdvancedSelect from '@/components/common/AdvancedSelect'
import { mask } from 'vue-the-mask'
import { mapActions, mapGetters } from 'vuex'
import AddDoctor from '@/components/common/AddDoctor'

export default {
  name: 'PatientNew',
  components: {
    subheader: SubHeader,
    'page-scroll-top': PageScrollTop,
    'card-form': CardForm,
    'advanced-select': AdvancedSelect,
    Spinner,
    AddDoctor
  },
  data: () => ({
    genderOptions: strings.genders,
    patient: {
      name: '',
      email: '',
      cpf: '',
      birthDate: null,
      gender: '',
      doctors: [],
      socialNameEnabled: false
    },
    isEdit: false,
    loading: false,
    searchInput: '',
    opened: false
  }),
  methods: {
    ...mapActions(['examIsProfile', 'clearExamList', 'getExamDetails', 'pushLoadingExam']),
    loadPatient(id) {
      if (id) {
        this.isEdit = true
        this.loading = true
        patientService
          .getPatientById(id)
          .then(res => {
            // normalize the date
            let birthDate = res.data.birthdate
            if (birthDate) {
              let date = birthDate.substr(8, 2)
              let month = birthDate.substr(5, 2)
              let year = birthDate.substr(0, 4)
              birthDate = new Date(year, month - 1, date)
            }
            let listDoctor = res.data.doctor_list
            if (listDoctor) {
              listDoctor = listDoctor.map(doctor => {
                return {
                  crm: doctor.crm,
                  id_doctor: doctor.id_doctor,
                  name: doctor.name,
                  uf: doctor.uf
                }
              })
            }
            let gender = res.data.gender
            if (gender) {
              if (gender === 'F') {
                gender = {
                  label: 'Feminino',
                  value: 'F'
                }
              } else {
                gender = {
                  label: 'Masculino',
                  value: 'M'
                }
              }
            }
            let cpf = res.data.cpf
            if (cpf) {
              cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
            }
            this.patient.name = res.data.name
            this.patient.cpf = cpf
            this.patient.birthDate = birthDate
            this.patient.doctors = listDoctor
            this.patient.gender = gender
            this.patient.email = res.data.email
            this.patient.social_name = res.data.social_name
            this.patient.socialNameEnabled = res.data.social_name ? true : false
            this.loading = false
          })
          .catch(err => {
            console.error('err -->', err)
            this.loading = false
            notify({
              title: 'AVISO:',
              message: 'Erro ao carregar paciente para edição.'
            })
          })
      }
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.handleCreate()
          return
        }
      })
    },
    handleCreate() {
      let doctors = this.patient.doctors.map(doctor => {
        return {
          id_doctor: doctor.id_doctor
        }
      })
      // normalize the date
      let birthdate = document.getElementById('dtNewBirthDate').value
      let date = birthdate.substr(0, 2)
      let month = birthdate.substr(3, 2)
      let year = birthdate.substr(6, 4)
      birthdate = year + '-' + month + '-' + date

      let cpf
      if (this.patient.cpf) {
        cpf = this.patient.cpf.replace(/[.-\s]/g, '')
      }

      let patient = {
        birthdate,
        name: this.patient.name,
        gender: this.patient.gender.value,
        cpf,
        email: this.patient.email,
        doctor_list: doctors,
        social_name: this.patient.socialNameEnabled ? this.patient.social_name : null
      }
      let msgText = 'criado'
      const endpoint = this.isEdit ? 'editPatient' : 'createPatient'
      this.openModal()

      if (this.isEdit) {
        patient.id_patient = this.$route.params.id
        msgText = 'atualizado'
      }
      patientService[endpoint](patient)
        .then(response => {
          if (response) {
            notify({
              message: 'Paciente ' + msgText + ' com sucesso!'
            })
            this.closeModal()
            this.$router.push('/patient')
          }
        })
        .catch(err => {
          if (err.response.data.code === 'PATIENT_CPF_ALREADY_EXIST') {
            notify({
              title: 'AVISO:',
              message: 'Não foi possível criar o paciente. Este CPF já está registrado.'
            })
          } else if (err.response.data.code === 'PATIENT_EMAIL_ALREADY_EXIST') {
            notify({
              title: 'AVISO:',
              message: 'Não foi possível criar o paciente. Este email já está registrado.'
            })
          } else {
            notify({
              title: 'AVISO:',
              message: 'Erro ao salvar paciente.'
            })
          }
          this.closeModal()
        })
    },
    handleNew() {
      this.name = ''
      this.author = ''
      this.clearExamList()
      this.closeModal()
    },
    closeModal() {
      this.$refs.transferModal.close()
    },
    openModal() {
      this.$refs.transferModal.open()
    },
    focusNextField(id) {
      document.getElementById(id).focus()
    },
    listDoctorsUpdated(data) {
      this.patient.doctors = data
    },
    birthDate() {
      return this.patient.birthDate
    }
  },
  computed: {
    ...mapGetters(['newExamsList', 'examIsLoading', 'profile']),
    cpfRequired() {
      return this.profile.laboratoryTypeOutputResult === 'DIAVERUM'
    },
    validateNameSize() {
      return false
    },
    title() {
      if (this.isEdit) return 'Editar paciente'
      return 'Novo paciente'
    }
  },
  directives: {
    mask: mask
  },
  mounted() {
    if (this.$route.query.newDoctor) {
      this.opened = true
    }
    this.loadPatient(this.$route.params.id)
  },
  beforeDestroy() {
    this.clearExamList()
    this.examIsProfile(false)
    this.loading = false
    this.isEdit = false
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

.patient-new {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 142px;

  .md-advanced-select {
    label {
      color: #7a7a7a !important;
    }
  }
  &__doctor {
    h3 {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 30px;
    }
  }
  &__modal {
    text-align: center;

    &-loading {
      min-height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h3 {
      font-family: Roboto;
      font-weight: 400;
      text-align: center;
      font-size: 20px;
      margin-top: 20px;
      letter-spacing: 0;
    }
  }
  &__modal-text {
    border-top: 1px solid #b8b7bf;
    padding-top: 20px;
    max-width: 270px;
    margin: 20px auto 0;
  }

  &__search-exams {
    margin-bottom: 30px;
  }

  &__text {
    margin-bottom: 10px;
    font-weight: normal;
    font-size: 22px;
    color: #7a7a7a;
  }

  &__loading {
    min-height: 65vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__container {
    width: 100%;
  }

  &__form {
    margin-bottom: 35px;
    p {
      font-size: 15px;
      letter-spacing: -0.3px;
      color: #303030;
      margin-bottom: 15px;
    }
    .card-form {
      &__container {
        border-radius: 6px;
        padding-bottom: 27px;
      }
    }
    .md-input-container {
      margin: 0 !important;
    }
  }

  &__footer {
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;

    .btn-bordered {
      padding: 5px 28px;
      text-transform: uppercase;
      background: none;
      border: 2px solid #7f1a54;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.8px;
      color: #7f1a54;
      height: 38px;
    }
    .btn-primary {
      text-transform: uppercase;
      padding: 5px 37px;
      border-radius: 3px;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.8px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 5px;
      }
    }
  }
}
</style>
